import ClipText from "@components/ClipText/ClipText";
import Image from "@components/Image";
import Link from "@components/Link";
import cx from "classnames";
import React from "react";
import styles from "./Stories.module.scss";
import Button from "@components/Button";
import { useTranslationContext } from "@providers/TranslationProvider";
import { useRouteContext } from "@providers/RouteProvider";

interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    };
    slug: string;
    tag: string;
    title: string;
    content: string | React.ReactNode;
  };
}

export default function Item({ data }: Props) {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <Link href={router.toUrl("storiesArticle", { slug: data.slug })}>
      <div className={cx(styles.item)}>
        <Image
          wrapperProps={{ className: cx(styles.image) }}
          src={data.image.src}
          alt={data.image.alt}
          layout="fill"
          objectFit="cover"
        />
        <div className={cx(styles.tag)}>{data.tag}</div>
        <div className={cx(styles.title)}>{data.title}</div>
        <ClipText fixedRows rows={4} className={cx(styles.content)}>
          {data.content}
        </ClipText>
        <Button
          type="icon"
          suffix="shape-arrow"
          className={cx(styles.readMore)}
          label={i18n.t("Button.readMore")}
          // onClick={() => {
          //   if (!!data?.slug)
          //     router.push("storiesArticle", { slug: data.slug });
          // }}
        />
      </div>
    </Link>
  );
}
